import Vue from "vue"
import VueRouter from "vue-router"
import routes from "./routes"
import generalIssuesMiddlewares from "./middlewares/generalIssues.middlewares"

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  mode: "history",
  linkActiveClass: "active",

  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    // Modal da lista de reservas usa #booking só no histórico; não rolar a página.
    if (
      to.hash === '#booking' &&
      String(to.path || '').indexOf('booking-list') !== -1
    ) {
      return false;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },

});

router.beforeEach(generalIssuesMiddlewares);

router.onError((error) => {
  console.log('ChunkLoadError...',error)
  if (error.name === 'ChunkLoadError') {
    window.location.reload(true)
  }
})

export default router;
